export default __webpack_public_path__ + "279545607bf324d401edda5241a15719.png";